export const SOCKET_IO = "[SOCKET] CONNECT IO";
export const SOCKET_NEW_ALERT = "[SOCKET] NEW ALERT";
export const SOCKET_CLEAR_ALERTS = "[SOCKET] CLEAR ALERTS";


